/**
 * External dependencies
 */
import Immerable from '@naruto/naruto-reducers/src/types/GeneralImmer';

/**
 * Internal dependencies
 */
import { Attachments } from './types';

class Attachment extends Immerable {
  public attachmentList: Attachments;

  public constructor() {
    super();
    this.attachmentList = {
      attachments: []
    };
  }

  public initialize(): void {
    this.attachmentList = {
      attachments: []
    };
  }

  public updateAttachmentList(newList: Attachments): void {
    this.attachmentList = newList;
  }

  public clearAttachmentList(): void {
    this.attachmentList = {
      attachments: []
    };
  }
}

export default Attachment;
